<template>
  <div>
    <h2>{{$t('TEXT_WITHDRAW')}} {{wallet.name}} ({{(wallet.displaySymbol)}})</h2>
    <form class="popup-inner" @submit.prevent="doWithdraw" :class="{ 'loading': isProcessing }">
      <div class="item">
        <label v-html="$t('TEXT_AMOUNT')"></label>
        <input
          type="text"
          autocomplete="off"
          required
          v-model="form.amount"
          :placeholder="`0.00 ${wallet.displaySymbol}`"
        >
        <span class="field-description error-text" v-if="form.amount && !isValidAmount">
          {{ $t('TEXT_MIN_WITHDRAW') }} {{minCurrencyWithdraw}}&nbsp;{{ wallet.displaySymbol }},
          {{ $t('TEXT_MAX_WITHDRAW') }} {{maxCurrencyWithdraw}}&nbsp;{{ wallet.displaySymbol }}
        </span>
        <span class="field-description error-text" v-if="form.amount && isValidAmount && isInValidAmountPrecision">
          {{ $t('MSG_MAXIMUM_AMOUNT_PRECISION_IS', { amountPrecision: this.wallet.numberDecimal}) }}
        </span>
        <span class="field-description error-text" v-else-if="isNaNAmount">
          {{ $t('MSG_AMOUNT_MUST_BE_A_NUMBER') }}
        </span>
        <p class="item-description">
          (
          <a :class="{'disabled': wallet.balance === 0}" @click="swapMax">
            <span >{{ $t('BTN_MAX') }}</span>
          </a>
          -
          <a :class="{'disabled': wallet.balance === 0}" @click="swapMin">
            <span>{{ $t('BTN_MIN') }}</span>
          </a>
          )
        </p>
      </div>
      <div class="item" v-if="wallet.mustInputAddressWithdraw">
        <label v-html="$t('TEXT_ADDRESS')"></label>
        <input
          autocomplete="off"
          required
          v-model="form.validateAddress"
          :placeholder="$t('TEXT_ADDRESS')" type="text"
        >
        <div class="flex-box" v-if="form.validateAddress && !isValidAddress">
          <div class="flex-grow buy-color">
            <span class="field-description error-text">
              {{ $t('TEXT_ADDRESS_NOT_VALID') }}
            </span>
          </div>
        </div>
      </div>
      <div class="item item-balance">{{ $t('TEXT_BALANCE') }}: <span>{{ wallet.beautyBalance }} {{wallet.displaySymbol}}</span></div>
      <div class="item item-fee">
        <div class="flex-box">
          <div style="flex-basis: 140px">{{ $t('TEXT_WITHDRAW_FEE') }}:</div>
          <div class="flex-grow dark-color">
            <span>{{ feeWithdraw }}</span>&nbsp;
            <span>{{ wallet.withdrawFeeSymbol || wallet.displaySymbol }}</span>
          </div>
        </div>
        <div class="flex-box">
          <div style="flex-basis: 140px">{{$t('TEXT_YOU_WILL_WITHDRAW')}}: </div>
          <div class="flex-grow buy-color">
            <span>{{ estimatedWithdrawalAmount }}</span>&nbsp;
            <span>{{ wallet.displaySymbol }}</span>
          </div>
        </div>
        <div class="flex-box">
          <div style="flex-basis: 140px">&nbsp;</div>
          <div class="flex-grow buy-color">
            <span class="field-description error-text" v-if="!isValidFeeAmount">
              {{ $t('MSG_FEE_IS_NOT_ENOUGH') }}
            </span>
          </div>
        </div>
      </div>
      <div class="item item-submit">
        <a class="btn btn-submit" :class="{ 'disabled': !isValidated }" @click="doWithdraw">{{ $t('BTN_WITHDRAW') }}</a>
      </div>
    </form>
  </div>
</template>

<script>
import UtilService from '@/utils/UtilService'
export default {
  props: {
    wallet: {},
    feeWallet: {}
  },
  data () {
    return {
      isValidAddress: false,
      form: {
        amount: null,
        validateAddress: ''
      },
      isProcessing: false
    }
  },
  watch: {
    'form.validateAddress' (val) {
      this.isValidAddress = UtilService.isValidWalletAddress(val, this.wallet)
    }
  },
  computed: {
    pagination () {
      return this.$store.getters.pagination
    },
    user () {
      return this.$store.getters.user
    },
    wallets () {
      return this.$store.getters.ieoBalances
    },
    isExternalFee () {
      return this.wallet.withdrawFeeSymbol && this.wallet.withdrawFeeSymbol !== this.wallet.symbol
    },
    isValidFeeAmount () {
      if (this.isExternalFee) {
        const result = UtilService.isLessOrEqual(this.feeWithdraw, this.feeWallet.balance)
        return result
      }
      return true
    },
    isValidAmount () {
      let result = null
      if (this.form.amount && UtilService.isLargerOrEqual(this.form.amount, this.minCurrencyWithdraw) &&
        UtilService.isLessOrEqual(this.form.amount, this.maxCurrencyWithdraw)) {
        result = true
      } else result = false
      return result
    },
    feeWithdraw () {
      return UtilService.calculateFeeWithdraw(this.form.amount, this.wallet)
    },
    maxCurrencyWithdraw () {
      let result = 0
      this.wallet.balanceMain > this.wallet.withdrawMaxAmount ? result = this.wallet.withdrawMaxAmount : result = this.wallet.balanceMain
      return UtilService.maxAmountWithoutFee(result, this.feeWithdraw, this.wallet)
    },
    estimatedWithdrawalAmount () {
      if (!this.form.amount) return 0
      return UtilService.estimateWithdrawAmount(this.form.amount, this.feeWithdraw, this.wallet)
    },
    configs () {
      return this.$store.getters.configs
    },
    minWithdraw () {
      return this.wallet.withdrawMinAmount || 0
    },
    minCurrencyWithdraw () {
      return this.minWithdraw || 0
    },
    isValidated () {
      let result = this.form.amount && this.isValidAmount && !this.isInValidAmountPrecision && !this.isNaNAmount &&
        this.isValidFeeAmount
      if (this.wallet.mustInputAddressWithdraw) {
        result = result && this.form.validateAddress && this.isValidAddress
      }
      return result
    },
    isInValidAmountPrecision () {
      return this.form.amount && !UtilService.checkValidAmountDecimals(this.form.amount, this.wallet.numberDecimal)
    },
    isNaNAmount () {
      return !this.isInValidAmount && this.form.amount && isNaN(this.form.amount)
    }
  },
  methods: {
    swapMax () {
      if (this.wallet.balanceMain > 0) {
        this.form.amount = this.maxCurrencyWithdraw
      }
    },
    swapMin () {
      if (this.wallet.balanceMain > 0) {
        this.form.amount = this.minCurrencyWithdraw
      }
    },
    doWithdraw () {
      if (!this.isValidated) return
      const data = {}
      data.currency = this.wallet.symbol
      data.amount = this.form.amount
      data.toAddress = this.form.validateAddress
      this.isProcessing = true
      this.$store.dispatch('withdraw', data).then(status => {
        setTimeout(() => {
          this.isProcessing = false
          if (status) {
            this.$store.dispatch('toggleAmountForm')
            this.$store.dispatch('getTransHistory', this.pagination.currentPage || 1)
          }
        }, 500)
      })
    }
  }
}
</script>
